import React, { useState } from "react";
import FullScreenLoadingOverlay from "./FullScreenLoadingOverlay";
import I18n from "i18n-js";


const UpdateSaleItemsStateButton = ({ userId, reloadPageUrl, setShowErrorModal }) => {

  const [refreshingSaleData, setRefreshingSaleData] = useState(false);

  const handleUpdateListingsStatus = () => {
    const url = `/users/${userId}/sale_items/all/refresh_states`;
    setRefreshingSaleData(true);
    fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    })
      .then((res) => {
        if (!res.ok)
          throw Error("An error occour during saving data on the database");
        else
          return res.json();
      })
      .then((data) => {
        window.location = reloadPageUrl;
      })
      .catch((error) => {
        console.error("ERROR:", error);
        setRefreshingSaleData(false);
        setShowErrorModal(true);
      });
  }

  return <React.Fragment>
    <button
      id="update_listings_status_btn"
      name="update_listings_status_btn"
      className="submission_lists_footer_button bg-intense-blue-imp color-white text-weight-500 border-none mr-2 my-1 text--white-space-no-wrap"
      onClick={handleUpdateListingsStatus}
    >
      {I18n.t('js.myCollectionEditPage.updateListingsStatus').toUpperCase()}
    </button>


    <FullScreenLoadingOverlay
      showFullScreenLoadingOverlay={refreshingSaleData}
      textFullScreenLoadingOverlay={I18n.t('js.myCollectionEditPage.updatingListingsStatus')}
    />
  </React.Fragment>
};

export default UpdateSaleItemsStateButton;